module.exports = __webpack_public_path__ + "static/media/nightMode.a6f579e1.svg";